var styles = {"wrapper":"team-group--wrapper","list":"team-group--list","listItem":"team-group--list-item","title":"team-group--title","wrapperModal":"team-group--wrapper-modal","modalHeader":"team-group--modal-header","modalText":"team-group--modal-text","wrapperImage":"team-group--wrapper-image","wrapperTitle":"team-group--wrapper-title"};

export { styles as default };
//# sourceMappingURL=TeamGroup.module.esm.js.map
